// On-canvas toolbar for the graph editors (ENG-1068/1069). Sits where the old
// "right-click to add nodes" hint was:
//   Search — open the node palette (add a node)
//   Tidy   — auto-arrange the whole graph left-to-right
//   ?      — toggle a legend of mouse / keyboard / arrange controls
// Presentational: the canvas passes onSearch / onTidy.
import { useState } from 'react'

const BTN = {
  font: 'inherit',
  fontFamily: 'var(--m-font)',
  fontSize: 10,
  lineHeight: 1,
  padding: '5px 9px',
  cursor: 'pointer',
  color: 'var(--m-fg-2)',
  background: 'var(--m-panel)',
  border: '1px solid var(--m-line-hi)',
  borderRadius: 4,
}

function Btn({ label, title, onClick }) {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      style={BTN}
      onMouseEnter={e => { e.currentTarget.style.background = 'var(--m-panel-hi)'; e.currentTarget.style.color = 'var(--m-fg)' }}
      onMouseLeave={e => { e.currentTarget.style.background = 'var(--m-panel)'; e.currentTarget.style.color = 'var(--m-fg-2)' }}
    >{label}</button>
  )
}

// The legend Bowen asked for: what's available and its shortcut.
const HELP = [
  ['Box-select', 'drag on empty canvas'],
  ['Add / remove from selection', 'Shift + click'],
  ['Pan', 'middle-drag, or Space + drag'],
  ['Zoom', 'mouse wheel'],
  ['Add a node', 'right-click, or Search'],
  ['Tidy whole graph', 'toolbar Tidy button'],
  ['Align left / right', 'Shift + A / D'],
  ['Align top / bottom', 'Shift + W / S'],
  ['Align center / middle', 'Shift + Alt + S / W'],
  ['Straighten connections', 'Q'],
  ['Align / distribute / straighten selection', 'right-click a node → Arrange'],
  ['Undo', 'Ctrl / Cmd + Z'],
]

function HelpPanel() {
  return (
    <div style={{
      position: 'absolute', top: 30, right: 0, width: 320,
      background: 'var(--m-panel)', border: '1px solid var(--m-line-hi)',
      borderRadius: 6, boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
      padding: '8px 10px', fontFamily: 'var(--m-font)', fontSize: 11,
      color: 'var(--m-fg-2)', zIndex: 20,
    }}>
      <div style={{ color: 'var(--m-fg-3)', fontSize: 9, letterSpacing: 0.5, textTransform: 'uppercase', marginBottom: 6 }}>Controls</div>
      {HELP.map(([what, how]) => (
        <div key={what} style={{ display: 'flex', justifyContent: 'space-between', gap: 14, padding: '3px 0' }}>
          <span>{what}</span>
          <span style={{ color: 'var(--m-fg-3)', whiteSpace: 'nowrap' }}>{how}</span>
        </div>
      ))}
    </div>
  )
}

export function GraphToolbar({ onSearch, onTidy, hint, style }) {
  const [showHelp, setShowHelp] = useState(false)
  return (
    <div style={{
      position: 'absolute', top: 10, right: 10, zIndex: 10,
      display: 'flex', gap: 6, alignItems: 'center',
      fontFamily: 'var(--m-font)',
      ...style,
    }}>
      {hint && (
        <span style={{ color: 'var(--m-fg-3)', fontSize: 10, marginRight: 4, pointerEvents: 'none' }}>{hint}</span>
      )}
      {onSearch && <Btn label="🔍 Search" title="Add a node (search the palette)" onClick={onSearch} />}
      {onTidy   && <Btn label="⤢ Tidy"   title="Auto-arrange the whole graph" onClick={onTidy} />}
      <Btn label="?" title="Controls & shortcuts" onClick={() => setShowHelp(v => !v)} />
      {showHelp && <HelpPanel />}
    </div>
  )
}
